import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { KeycloakService } from 'keycloak-angular';
import { CookieService } from 'ngx-cookie-service';
import { async, map, tap } from 'rxjs';
import { BackendApiService } from 'src/app/service/backend-api.service';
import { config } from 'src/app/config/api.config';
import { PlateformeLMSService } from 'src/app/modules/plateforme-lms/services/plateforme-lms.service';
import { ProgrammeCoursera } from 'src/app/model/programme-coursera';
import { environment } from 'src/environments/environments';

import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
@Component({
  selector: 'app-side-bar-apprenant-stemd',
  templateUrl: './side-bar-apprenant-stemd.component.html',
  styleUrls: ['./side-bar-apprenant-stemd.component.css'],
  animations: [
    trigger('slideToggle', [
      state('open', style({ height: '*', opacity: 1, overflow: 'hidden' })),
      state('closed', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
      transition('open <=> closed', [animate('300ms ease-in-out')]),
    ]),
  ],
  encapsulation: ViewEncapsulation.None,
})
export class SideBarApprenantStemdComponent {
  constructor(private router: Router) {}

  user: any | null;
  profil: any;
  logged: any;
  role!: any;
  cohorte!: string;
  nomrole!: string;

  sections = [
    { id: 1, isCollapsed: true },
    { id: 2, isCollapsed: true },
    { id: 3, isCollapsed: true },
    { id: 4, isCollapsed: true },
  ];
  urlPlateformeScience = 'https://sciences.force-n.sn/auth/oidc';
  urlScholarVox = 'https://skills.scholarvox.com/forcen';

  ngOnInit() {
    this.user = sessionStorage.getItem('user');
    this.logged = sessionStorage.getItem('logged');
    this.profil = JSON.parse(this.user).profile.id;

    this.role = JSON.parse(this.user)?.roles;
    this.cohorte = JSON.parse(
      this.user
    ).beneficiaryCohortes[0]?.cohorte.cohorteName;

    // console.log("user side bar apprenant stemd", this.user);
  }
  reloadComponent(self: boolean, urlToNavigateTo?: string) {
    //skipLocationChange:true means dont update the url to / when navigating
    const url = self ? this.router.url : urlToNavigateTo;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([`/${url}`]).then(() => {
        // console.log(`After navigation I am on:${this.router.url}`);
      });
    });
  }
  sessionChange(cohorte: string) {
    sessionStorage.setItem('cohorte', cohorte);
    this.router.navigate(['dashboard/appels/candidatures/' + cohorte]);
    setTimeout(() => {
      this.reloadComponent(false, 'dashboard/appels/candidatures/' + cohorte);
    }, 500);
  }
  openUrl(url: string) {
    window.open(url, '_blank');
  }

  toggleCollapse(id: number): void {
    const section = this.sections.find((sec) => sec.id === id);
    if (section) {
      section.isCollapsed = !section.isCollapsed;
    }
  }
}
